import { CreateTenantRoleCommand, RolesApi, TenantRoleDto, UpdateTenantRoleCommand } from '@admin/app/api'
import { createApiClient } from '@admin/app/http-client'

export class RoleService {
  private readonly httpClient = createApiClient(RolesApi)

  async load(): Promise<TenantRoleDto[]> {
    const { data } = await this.httpClient.rolesGet()
    return data
  }

  async loadPermissions(): Promise<string[]> {
    const { data } = await this.httpClient.rolesGetPermissions()
    return data
  }

  async create(request: CreateTenantRoleCommand): Promise<number> {
    const { data } = await this.httpClient.rolesCreate(request)
    return data
  }

  async update(request: UpdateTenantRoleCommand): Promise<void> {
    await this.httpClient.rolesUpdate(request.id, request)
  }

  async delete(id: number): Promise<void> {
    await this.httpClient.rolesDelete(id)
  }
}

export const roleService = new RoleService()
